import Enums from "@/enums/enums";
import userInfo from "@/function/userInfo";
import i18n from "@/locales/i18n";
import * as API from "@/service/ApiConfig";
import tableFacade, { GetAllocationTableRequest } from "@/service/table/tableFacade";

export default {
  //#region Import
  DoGetImportTable(input) {
    let _input = tableFacade.GetImportTableInput(input);
    return API.peakAPI.post("/api/Table/GetImportTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region Contact
  DoGetContactTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      tableContactView: {
        tableStatus: input.tableStatus,
        searchText: input.searchText,
        tableSorting: input.tableSorting,
        contactTableView: input.contactTableView,
        contactGroupId: input.contactGroupId,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
      },
    };
    return API.peakAPI.post("/api/Table/GetContactTableForNewPeak", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetContactGroupList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI.post("/api/Table/GetContactGroupList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region Product
  DoGetProductTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      tableProductView: {
        tableStatus: input.tableStatus,
        searchText: "",
        tableSorting: input.tableSorting,
        productTableView: input.transactionTableView,
        year: "2020",
        pageNo: input.pageNo,
        pageSize: input.pageSize,
      },
    };

    return API.peakAPI.post("/api/Table/GetProductTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetUnitTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      unitType: input.unitType,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
      isDeleted: false,
      isUseMainDatabase: input.isUseMainDatabase,
    };

    return API.peakAPI.post("/api/Product/GetUnitTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  //#endregion
  //#region Finance
  DoGetChequeAbleToReceiveTable(paymentInOutFlowType, rowNumber) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      rowNumber: rowNumber,
      paymentInOutFlowType: paymentInOutFlowType,
    };
    return API.peakAPI
      .post("/api/Table/GetChequeAbleToReceiveTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequeWaitingReceiveTable(paymentInOutFlowType, rowNumber) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      rowNumber: rowNumber,
      paymentInOutFlowType: paymentInOutFlowType,
    };
    return API.peakAPI
      .post("/api/Table/GetChequeWaitingReceiveTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedChequeTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      paymentInOutFlowType: input.paymentInOutFlowType,
      chequeSearch: {
        dateType: input.dateType,
        fromDate: input.fromDate,
        toDate: input.toDate,
        searchContactName: input.searchContactName,
        searchTransactionNumber: input.searchTransactionNumber,
        searchBankAccountName: input.searchBankAccountName,
        searchChequeCode: input.searchChequeCode,
        fromNetAmount: input.fromNetAmount,
        toNetAmount: input.toNetAmount,
        orderText: input.orderText,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
      },
    };
    return API.peakAPI.post("/api/Table/GetReceivedChequeTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeCount(paymentInOutFlowType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      paymentInOutFlowType: paymentInOutFlowType,
    };
    return API.peakAPI.post("/api/Table/GetChequeCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  async DoGetPaymentTransferTable(input) {
    return API.peakAPI.post("/api/table/getpaymentfiletable", input, userInfo.SetHeaderService());
  },
  DoGetPaymentTransferTableCount(input) {
    return API.peakAPI.post("/api/table/GetPaymentFileTableCount", input, userInfo.SetHeaderService());
  },
  DoGetExpenseForCreatePaymentTransfer(input) {
    return API.peakAPI.post("/api/table/GetExpenseForCreatePaymentFileTable", input, userInfo.SetHeaderService());
  },
  DoGetExpenseForCreatePaymentTransferTableCount(input) {
    return API.peakAPI.post("/api/table/GetExpenseForCreatePaymentFileTableCount", input, userInfo.SetHeaderService());
  },
  DoGetExpenseDetailForCreatePayment(input) {
    return API.peakAPI.post("/api/table/GetExpenseDetailForCreatePayment", input, userInfo.SetHeaderService());
  },
  DoGetSuggestedTransactionNumber(input) {
    return API.peakRealTimeAPI.post("/api/Transaction/GetSuggestionTransactionNumber", input);
  },

  //#endregion
  //#region Journal
  DoGetJournalTable(input) {
    let _input = tableFacade.GetJournalTableRequest(input);
    return API.peakAPI.post("/api/Table/GetJournalTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetJournalTableAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalTableCount(input) {
    let _input = tableFacade.GetJournalTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetJournalTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetJournalTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoUpdateJournalStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: input.journalId,
      statusId: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/UpdateJournalStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableJournal(input) {
    let _input = {
      settingTableJournal: tableFacade.GetUpdateSettingTableRequest(input, Enums.SettingTableDocumentType.DailyJournal),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Journal/UpdateSettingTableJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableJournal(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Journal/GetSettingTableJournal", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region UploadDocument
  DoGetUploadDocumentTable(input) {
    let _input = tableFacade.GetUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUploadDocumentTableCount(input) {
    let _input = tableFacade.GetUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetUploadDocumentTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetInvoiceForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetInvoiceForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountInvoiceForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetInvoiceForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountInvoiceForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetQuotationForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetQuotationForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountQuotationForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetQuotationForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountQuotationForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetCreditNoteForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCreditNoteForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountCreditNoteForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetCreditNoteForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post(
        "/api/UploadDocument/GetCountCreditNoteForReferenceUploadDocumentTable",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetDebitNoteForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetDebitNoteForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountDebitNoteForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetDebitNoteForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountDebitNoteForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetBillingNoteForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetBillingNoteForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountBillingNoteForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetBillingNoteForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post(
        "/api/UploadDocument/GetCountBillingNoteForReferenceUploadDocumentTable",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetDepositForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetDepositForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetDepositForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountDepositForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetDepositForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountDepositForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetReceiptForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetReceiptForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountReceiptForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetReceiptForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountReceiptForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetJournalForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetJournalForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountJournalForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetJournalForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountJournalForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetWhtForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetWhtForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetWhtForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountWhtForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetWhtForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountWhtForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region Recurring
  DoGetRecurringTableTable(input) {
    let _input = tableFacade.GetRecurringTableInput(input);
    return API.peakAPI.post("/api/Table/GetRecurringTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region CashBank
  DoGetCashBankList(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      referenceTypeId: input.referenceTypeId,
      dateTime: input.dateTime,
      language: i18n.locale,
      accountTypeId: input.accountTypeId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetCashBankList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFinanceTableCount(input) {
    const _input = {
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      bankAccountId: input.bankAccountId,
      isJournalDeleted: input.isJournalDeleted,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetFinanceTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFinanceTotal(input) {
    const _input = {
      isJournalDeleted: input.isJournalDeleted,
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakReportAPI.post("/api/Finance/GetFinanceTotal", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFinanceTable(input) {
    const _input = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      isJournalDeleted: input.isJournalDeleted,
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetFinanceTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFinanceTableForReconcileCount(input) {
    const _input = {
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      isJournalDeleted: input.isJournalDeleted,
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Finance/GetFinanceTableForReconcileCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceTableForReconcile(input) {
    const _input = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      isJournalDeleted: input.isJournalDeleted,
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Finance/GetFinanceTableForReconcile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentBankStatementTableCount(input) {
    const _input = {
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/PaymentBankStatement/GetPaymentBankStatementTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentBankStatementTable(input) {
    const _input = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/PaymentBankStatement/GetPaymentBankStatementTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentBankStatementForReconcileTableCount(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post(
        "/api/PaymentBankStatement/GetPaymentBankStatementForReconcileTableCount",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentBankStatementForReconcileTable(input) {
    const _input = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/PaymentBankStatement/GetPaymentBankStatementForReconcileTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSummaryTableAccountFinance(input) {
    let _input = {
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      bankAccountId: input.bankAccountId,
      isShowJournalDeleted: input.isShowJournalDeleted,
    };
    return API.peakAPI
      .post("/api/Finance/GetSummaryTableAccountFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentBankStatementById(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      paymentBankStatementIdList: input.paymentBankStatementIdList,
    };
    return API.peakAPI
      .post("/api/PaymentBankStatement/GetPaymentBankStatementById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceById(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      peakPaymentIdList: input.peakPaymentIdList,
    };
    return API.peakAPI.post("/api/Finance/GetFinanceById", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetPaymentTransactionByPaymentGroupId(paymentGroupIdList) {
    const _input = {
      paymentGroupIdList: paymentGroupIdList,
    };
    return API.peakAPI
      .post("/api/Finance/GetPaymentTransactionByPaymentGroupId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequeFinanceTableCount(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      paymentInOutFlowType: input.paymentInOutFlowType,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Table/GetChequeTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeFinanceTable(input) {
    let _input = {
      pageNo: input.pageNo,
      pageSize: input.pageSize,
      fromDate: input.fromDate,
      toDate: input.toDate,
      paymentInOutFlowType: input.paymentInOutFlowType,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Table/GetChequeTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeTable(input) {
    let _input = {
      pageNo: input.pageNo,
      pageSize: input.pageSize,
      fromDate: input.fromDate,
      toDate: input.toDate,
      searchText: input.searchText,
      paymentInOutFlowType: input.paymentInOutFlowType,
      isReceived: input.isReceived,
      transactionTableView: input.sortBy,
      tableSorting: input.sortType,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Table/GetChequeAbleToReceiveTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequePayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      paymentInOutFlowTypeId: input.paymentInOutFlowTypeId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetChequeNotReceived", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetSummaryTableBankStatement(input) {
    const params = tableFacade.GetSummaryTableBankStatementParams(input);
    const headers = userInfo.SetHeaderService().headers;
    return API.peakAPI
      .get("/api/PaymentBankStatement/GetSummaryTableBankStatement/" + input.bankAccountId, { params, headers })
      .then((res) => {
        return res;
      });
  },
  ValidateIsCanDeleteFinance(bankAccountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: bankAccountId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/ValidateIsCanDeleteFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DeleteBankAccount(bankAccountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: bankAccountId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Finance/DeleteBankAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCashBankListForGraph(input) {
    let _input = {
      bankAccountId: input.bankAccountId,
      date: input.dateTime,
      periodTypeId: input.periodTypeId,
      isShowJournalDeleted: input.isShowJournalDeleted,
    };
    return API.peakAPI.post("/api/Finance/GetCashBankListForGraph", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoEditRemarkCashBankDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      peakPaymentId: input.id,
      remark: input.remark,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Finance/EditRemarkCashBankDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdatePaymentBankStatement(input) {
    let _input = {
      bankAccountId: input.bankAccountId,
      paymentBankStatement: {
        id: input.id,
        paymentAmount: input.amount,
        paymentDate: input.paymentDate,
        remark: input.remark,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PaymentBankStatement/UpdatePaymentBankStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRemarkPaymentBankStatement(input) {
    let _input = {
      bankAccountId: input.bankAccountId,
      paymentBankStatement: {
        id: input.id,
        remark: input.remark,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PaymentBankStatement/UpdateRemarkPaymentBankStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBankReconciledIdIsNotApprovedCount(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/BankReconciled/GetBankReconciledIdIsNotApprovedCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBankReconciledIdIsNotApproved(input) {
    const _input = {
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      bankAccountId: input.bankAccountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/BankReconciled/GetBankReconciledIdIsNotApproved", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentReconciledGroupWithPaymentTransactionByReconciledGroupId(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      reconciledGroupIdList: input.reconciledGroupIdList,
    };
    return API.peakAPI
      .post(
        "/api/Finance/GetPaymentReconciledGroupWithPaymentTransactionByReconciledGroupId",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentReconciledGroupWithBankStatementByReconciledGroupId(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      reconciledGroupIdList: input.reconciledGroupIdList,
    };
    return API.peakAPI
      .post(
        "/api/PaymentBankStatement/GetPaymentReconciledGroupWithBankStatementByReconciledGroupId",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetBankReconciledDetailById(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      reconciledGroupIdList: input.reconciledGroupIdList,
    };
    return API.peakAPI
      .post("/api/BankReconciled/GetBankReconciledDetailById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region Wht
  DoGetWhtTable(input) {
    const _input = tableFacade.GetWhtTableRequest(input);

    return API.peakAPI.post("/api/Table/GetWhtTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetWhtTableCount(input) {
    const _input = tableFacade.GetWhtTableCountRequest(input);

    return API.peakAPI.post("/api/Table/GetWhtTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region setting
  DoGetUserTable(input) {
    let _input = {
      pageNumber: input.pageNo,
      pageSize: input.pageSize,
      searchText: input.searchText,
      userOrderBy: input.transactionTableView,
      tableSorting: input.tableSorting,
    };
    return API.peakAPI.post("/api/User/GetUserTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetUserTableV2(input) {
    let _input = {
      pageNumber: input.pageNo,
      pageSize: input.pageSize,
      searchText: input.searchText,
      userOrderBy: input.transactionTableView,
      tableSorting: input.tableSorting,
    };
    return API.peakAPI.post("/api/v2/User/GetUserTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetUserRoleTable(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { pageSize: input.pageSize, pageNumber: input.pageNumber };

    return API.peakAPI.get("/api/user/getroletable", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetUserInvitationTable(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { pageSize: input.pageSize, pageNumber: input.pageNumber };

    return API.peakAPI.get("/api/user/GetInvitationTable", { params, headers }).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region allocation
  DoGetAllocationTableList(input) {
    const _input = GetAllocationTableRequest(input);

    return API.peakAPI.post("/api/Table/GetAllocationTableList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region product
  DoGetNewProductTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: input.isUseMainDatabase,
      productTableSearchCriteria: {
        type: input.type,
        isArchived: input.isArchived,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        orderRowType: input.orderRowType,
        sortingType: input.tableSorting,
        searchText: input.searchText,
      },
    };
    return API.peakAPI.post("/api/Table/GetNewProductTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetServiceTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: input.isUseMainDatabase,
      productTableSearchCriteria: {
        type: input.type,
        isArchived: input.isArchived,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        orderRowType: input.orderRowType,
        sortingType: input.tableSorting,
        searchText: input.searchText,
      },
    };
    return API.peakAPI.post("/api/Table/GetNewProductTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetLotTableByLotSequenceNumber(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      productTemplateId: input.productTemplateId,
      lotSequenceNumber: input.lotSequenceNumber,
    };

    return API.peakAPI.get("/api/Product/GetLotTableByLotSequenceNumber", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetStockActivityTable(input) {
    let _input = tableFacade.GetStockActivityTableRequest(input);
    return API.peakAPI.post("/api/Product/GetStockActivityTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetStockActivityTableCount(input) {
    let _input = tableFacade.GetStockActivityTableCountRequest(input);
    return API.peakAPI
      .post("/api/Product/GetStockActivityTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region InvoiceTable
  DoGetInvoiceTable(input) {
    let _input = tableFacade.GetInvoiceTableRequest(input);
    return API.peakAPI.post("/api/Table/GetInvoiceTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetInvoiceTableAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableCount(input) {
    let _input = tableFacade.GetInvoiceTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetInvoiceTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetInvoiceTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableIncomeByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableIncomeByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableIncomeCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableIncomeCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableExpenseByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableExpenseByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableExpenseCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableExpenseCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateInvoiceStatus(input) {
    let _input = {
      invoiceId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdateInvoiceStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateInvoiceSaleAssetStatus(input) {
    let _input = {
      invoiceSaleAssetId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdateInvoiceSaleAssetStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdatePurchaseInventoryStatus(input) {
    let _input = {
      purchaseInventoryId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdatePurchaseInventoryStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdatePurchaseAssetStatus(input) {
    let _input = {
      purchaseAssetId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdatePurchaseAssetStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableInvoice(input) {
    let _input = {
      settingTableInvoice: tableFacade.GetUpdateSettingTableRequest(input, Enums.SettingTableDocumentType.Invoice),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdateSettingTableInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableInvoice(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Invoice/GetSettingTableInvoice", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ExpenseTable
  DoGetExpenseTable(input) {
    let _input = tableFacade.GetExpenseTableRequest(input);
    return API.peakAPI.post("/api/Table/GetExpenseTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetExpenseTableAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseTableCount(input) {
    let _input = tableFacade.GetExpenseTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetExpenseTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetExpenseTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateInvoiceReceiptStatusGotReceiptList(input) {
    let _input = {
      invoiceReceiptIdList: input.invoiceReceiptIdList,
      isVoid: input.isVoid,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/UpdateInvoiceReceiptStatusGotReceiptList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateExpenseStatusGotReceiptList(expenseGotReceiptListModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      expenseGotReceiptListModel: expenseGotReceiptListModel,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdateExpenseStatusGotReceiptList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceiptStatus(input) {
    let _input = {
      receiptId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/UpdateReceiptStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceiptSaleAssetStatus(input) {
    let _input = {
      receiptSaleAssetId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/UpdateReceiptSaleAssetStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTablePurchaseInventory(input) {
    let _input = {
      settingTablePurchaseInventory: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.PurchaseInventoryRecord
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdateSettingTablePurchaseInventory", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTablePurchaseInventory(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Invoice/GetSettingTablePurchaseInventory", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableExpense(input) {
    let _input = {
      settingTableExpense: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.ExpenseRecord
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdateSettingTableExpense", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableExpense(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Invoice/GetSettingTableExpense", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseAssetTable
  DoGetPurchaseAssetTable(input) {
    let _input = tableFacade.GetPurchaseAssetTableRequest(input);
    return API.peakAPI.post("/api/Table/GetPurchaseAssetTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetPurchaseAssetTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableCount(input) {
    let _input = tableFacade.GetPurchaseAssetTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTablePurchaseAsset(input) {
    let _input = {
      settingTablePurchaseAsset: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.PurchaseAsset
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Invoice/UpdateSettingTablePurchaseAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTablePurchaseAsset(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Invoice/GetSettingTablePurchaseAsset", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region QuotationTable
  DoGetQuotationTable(input) {
    let _input = tableFacade.GetQuotationTableRequest(input);
    return API.peakAPI.post("/api/Table/GetQuotationTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetQuotationTableAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationTableCount(input) {
    let _input = tableFacade.GetQuotationTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetQuotationTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetQuotationTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateQuotationStatus(input) {
    let _input = {
      quotationId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateQuotationStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdatePurchaseOrderStatus(input) {
    let _input = {
      purchaseOrderId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdatePurchaseOrderStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdatePurchaseOrderAssetStatus(input) {
    let _input = {
      purchaseOrderAssetId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdatePurchaseOrderAssetStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAcceptedQuotation(input) {
    let _input = {
      quotationId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateAcceptedQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateRejectQuotation(input) {
    let _input = {
      quotationId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateRejectQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableQuotation(input) {
    let _input = {
      settingTableQuotation: tableFacade.GetUpdateSettingTableRequest(input, Enums.SettingTableDocumentType.Quotation),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateSettingTableQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableQuotation(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Quotation/GetSettingTableQuotation", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseOrderTable
  DoGetPurchaseOrderTable(input) {
    let _input = tableFacade.GetPurchaseOrderTableRequest(input);
    return API.peakAPI.post("/api/Table/GetPurchaseOrderTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetPurchaseOrderTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableCount(input) {
    let _input = tableFacade.GetPurchaseOrderTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceNumberListReferenceQuotation(input) {
    let _input = {
      quotationIdList: input.quotationIdList,
      financeType: input.financeType,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceNumberListReferenceQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTablePurchaseOrder(input) {
    let _input = {
      settingTablePurchaseOrder: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.PurchaseOrder
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateSettingTablePurchaseOrder", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTablePurchaseOrder(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Quotation/GetSettingTablePurchaseOrder", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseOrderAssetTable
  DoGetPurchaseOrderAssetTable(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableCount(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTablePurchaseOrderAsset(input) {
    let _input = {
      settingTablePurchaseOrderAsset: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.PurchaseOrderAsset
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Quotation/UpdateSettingTablePurchaseOrderAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTablePurchaseOrderAsset(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Quotation/GetSettingTablePurchaseOrderAsset", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ReceiptTable
  DoGetReceiptTable(input) {
    let _input = tableFacade.GetReceiptTableRequest(input);
    return API.peakAPI.post("/api/Table/GetReceiptTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceiptTableAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptTableCount(input) {
    let _input = tableFacade.GetReceiptTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetReceiptTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceiptTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableReceipt(input) {
    let _input = {
      settingTableReceipt: tableFacade.GetUpdateSettingTableRequest(input, Enums.SettingTableDocumentType.Receipt),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Receipt/UpdateSettingTableReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableReceipt(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Receipt/GetSettingTableReceipt", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region TaxInvoiceTable
  DoGetTaxInvoiceTable(input) {
    let _input = tableFacade.GetTaxInvoiceTableRequest(input);
    return API.peakAPI.post("/api/Table/GetTaxInvoiceTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTaxInvoiceTableAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceTableCount(input) {
    let _input = tableFacade.GetTaxInvoiceTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetTaxInvoiceTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTaxInvoiceTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateTaxInvoiceStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/UpdateTaxInvoiceStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableTaxInvoice(input) {
    let _input = {
      settingTableTaxInvoice: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.SalesTaxInvoice
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/UpdateSettingTableTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableTaxInvoice(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/TaxInvoice/GetSettingTableTaxInvoice", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseTaxInvoiceTable
  DoGetPurchaseTaxInvoiceTable(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableCount(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTablePurchaseTaxInvoice(input) {
    let _input = {
      settingTablePurchaseTaxInvoice: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.PurchaseTaxInvoice
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/TaxInvoice/UpdateSettingTablePurchaseTaxInvoice", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTablePurchaseTaxInvoice(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/TaxInvoice/GetSettingTablePurchaseTaxInvoice", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region CreditNoteTable
  DoGetCreditNoteTable(input) {
    let _input = tableFacade.GetCreditNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetCreditNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetCreditNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteTableCount(input) {
    let _input = tableFacade.GetCreditNoteTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetCreditNoteTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetCreditNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateCreditNoteStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/UpdateCreditNoteStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableCreditNote(input) {
    let _input = {
      settingTableCreditNote: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.CreditNote
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/UpdateSettingTableCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableCreditNote(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/CreditNote/GetSettingTableCreditNote", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ReceivedCreditNoteTable
  DoGetReceivedCreditNoteTable(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableCount(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableReceivedCreditNote(input) {
    let _input = {
      settingTableReceivedCreditNote: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.ReceiveCreditNote
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/CreditNote/UpdateSettingTableReceivedCreditNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableReceivedCreditNote(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/CreditNote/GetSettingTableReceivedCreditNote", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region DebitNoteTable
  DoGetDebitNoteTable(input) {
    let _input = tableFacade.GetDebitNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetDebitNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDebitNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableCount(input) {
    let _input = tableFacade.GetDebitNoteTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetDebitNoteTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDebitNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableIncomeByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableIncomeByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableIncomeCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableIncomeCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateDebitNoteStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/UpdateDebitNoteStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableDebitNote(input) {
    let _input = {
      settingTableDebitNote: tableFacade.GetUpdateSettingTableRequest(input, Enums.SettingTableDocumentType.DebitNote),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/UpdateSettingTableDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableDebitNote(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/DebitNote/GetSettingTableDebitNote", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ReceivedDebitNoteTable
  DoGetReceivedDebitNoteTable(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetReceivedDebitNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceivedDebitNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableCount(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableById(input) {
    let _input = {
      isUseMainDatabase: false,
      debitNoteIdList: input.transactionIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI.post("/api/Table/GetDebitNoteTableById", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDebitNoteTableExpenseByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableExpenseByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableExpenseCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableExpenseCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableReceivedDebitNote(input) {
    let _input = {
      settingTableReceivedDebitNote: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.ReceiveDebitNote
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/DebitNote/UpdateSettingTableReceivedDebitNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableReceivedDebitNote(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/DebitNote/GetSettingTableReceivedDebitNote", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region BillingNoteTable
  DoGetBillingNoteTable(input) {
    let _input = tableFacade.GetBillingNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetBillingNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBillingNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableCount(input) {
    let _input = tableFacade.GetBillingNoteTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetBillingNoteTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBillingNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForCreateBillingNoteTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      createBillingNoteSearchCriteria: {
        contactId: input.contactId,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        tableSorting: input.tableSorting,
        transactionTableView: input.transactionTableView,
        financeType: input.financeType,
        editBillingNoteId: input.editBillingNoteId,
      },
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceForCreateBillingNoteTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateBillingNoteStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/UpdateBillingNoteStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableById(input) {
    let _input = {
      isUseMainDatabase: false,
      invoiceIdList: input.transactionIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI.post("/api/Table/GetInvoiceTableById", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateSettingTableBillingNote(input) {
    let _input = {
      settingTableBillingNote: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.BillingNote
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/UpdateSettingTableBillingNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableBillingNote(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/BillingNote/GetSettingTableBillingNote", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableIncomeByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableIncomeByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableIncomeCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableIncomeCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableExpenseByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableExpenseByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableExpenseCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableExpenseCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region CombinePaymentNote
  DoGetCombinePaymentNoteTable(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableCount(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableCombinePaymentNote(input) {
    let _input = {
      settingTableCombinePaymentNote: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.CombinedPaymentNote
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/BillingNote/UpdateSettingTableCombinePaymentNote", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableCombinePaymentNote(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/BillingNote/GetSettingTableCombinePaymentNote", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region DepositTable
  DoGetSelectedDepositTable(depositIdList) {
    let _input = {
      depositIdList: depositIdList,
    };
    return API.peakAPI.post("/api/Table/GetSelectedDepositTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDepositTable(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI.post("/api/Table/GetDepositTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDepositTableCount(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Table/GetDepositTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateDepositStatus(input) {
    let _input = {
      depositId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/UpdateDepositStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositItemForSearchByDepositIdList(depositIdList) {
    let _input = {
      depositIdList: depositIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositItemForSearchByDepositIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositAllocationItemForTable(depositIdList) {
    let _input = {
      depositIdList: depositIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositAllocationItemForTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableDeposit(input) {
    let _input = {
      settingTableDeposit: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.DepositReceipt
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/UpdateSettingTableDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableDeposit(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Deposit/GetSettingTableDeposit", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetDepositTableIncomeByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositTableIncomeByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositTableIncomeCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositTableIncomeCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositTableById(input) {
    let _input = {
      isUseMainDatabase: false,
      depositIdList: input.transactionIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI.post("/api/Table/GetDepositTableById", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDepositTableExpenseByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositTableExpenseByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositTableExpenseCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositTableExpenseCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ReceiveDepositTable
  DoGetReceivedDepositTable(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Table/GetReceivedDepositTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceivedDepositTableCount(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Table/GetReceivedDepositTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceivedDepositStatus(input) {
    let _input = {
      receivedDepositId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/UpdateReceivedDepositStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableReceivedDeposit(input) {
    let _input = {
      settingTableReceivedDeposit: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.DepositPayment
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Deposit/UpdateSettingTableReceivedDeposit", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableReceivedDeposit(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/Deposit/GetSettingTableReceivedDeposit", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetDepositTableExpenseByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositTableExpenseByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDepositTableExpenseCountByDate(input) {
    let _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };
    return API.peakAPI
      .post("/api/Table/GetDepositTableExpenseCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseRequisitionTable
  DoGetPurchaseRequisitionTable(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetPurchaseRequisitionTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseRequisitionTableCount(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Table/GetPurchaseRequisitionTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseRequisitionItemForSearchByPurchaseRequisitionIdList(purchaseRequisitionIdList) {
    let _input = {
      purchaseRequisitionIdList: purchaseRequisitionIdList,
    };
    return API.peakAPI
      .post(
        "/api/Table/GetPurchaseRequisitionItemForSearchByPurchaseRequisitionIdList",
        _input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseRequisitionAllocationItemForTable(purchaseRequisitionIdList) {
    let _input = {
      purchaseRequisitionIdList: purchaseRequisitionIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetPurchaseRequisitionAllocationItemForTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdatePurchaseRequisitionStatus(input) {
    let _input = {
      purchaseRequisitionId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/UpdatePurchaseRequisitionStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTablePurchaseRequisition(input) {
    let _input = {
      settingTablePurchaseRequisition: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.PurchaseRequisition
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/PurchaseRequisition/UpdateSettingTablePurchaseRequisition", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTablePurchaseRequisition(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/PurchaseRequisition/GetSettingTablePurchaseRequisition", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region GoodsReceiptTable
  DoGetGoodsReceiptTable(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI.post("/api/Table/GetGoodsReceiptTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetGoodsReceiptTableCount(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Table/GetGoodsReceiptTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetGoodsReceiptItemForSearchByGoodsReceiptIdList(goodsReceiptIdList) {
    let _input = {
      goodsReceiptIdList: goodsReceiptIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetGoodsReceiptItemForSearchByGoodsReceiptIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetGoodsReceiptAllocationItemForTable(goodsReceiptIdList) {
    let _input = {
      goodsReceiptIdList: goodsReceiptIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetGoodsReceiptAllocationItemForTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateGoodsReceiptStatus(input) {
    let _input = {
      goodsReceiptId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/UpdateGoodsReceiptStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableGoodsReceipt(input) {
    let _input = {
      settingTableGoodsReceipt: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.GoodsReceipt
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/GoodsReceipt/UpdateSettingTableGoodsReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableGoodsReceipt(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/GoodsReceipt/GetSettingTableGoodsReceipt", { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region InvoiceReceiptTable
  DoGetInvoiceReceiptTable(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI.post("/api/Table/GetInvoiceReceiptTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetInvoiceReceiptTableCount(input) {
    let _input = {
      isDeleted: input.isDeleted,
      fromDate: input.fromDate,
      toDate: input.toDate,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptItemForSearchByInvoiceReceiptIdList(invoiceReceiptIdList) {
    let _input = {
      invoiceReceiptIdList: invoiceReceiptIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptItemForSearchByInvoiceReceiptIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptAllocationItemForTable(invoiceReceiptIdList) {
    let _input = {
      invoiceReceiptIdList: invoiceReceiptIdList,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptAllocationItemForTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateInvoiceReceiptStatus(input) {
    let _input = {
      invoiceReceiptId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/UpdateInvoiceReceiptStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateSettingTableInvoiceReceipt(input) {
    let _input = {
      settingTableInvoiceReceipt: tableFacade.GetUpdateSettingTableRequest(
        input,
        Enums.SettingTableDocumentType.InvoiceReceipt
      ),
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/InvoiceReceipt/UpdateSettingTableInvoiceReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSettingTableInvoiceReceipt(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {};

    return API.peakRealTimeAPIForTransaction
      .get("/api/InvoiceReceipt/GetSettingTableInvoiceReceipt", { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptTableById(input) {
    let _input = {
      isUseMainDatabase: false,
      invoiceReceiptIdList: input.transactionIdList,
      billingNoteId: input.billingNoteId,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptTableById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptTableByDate(input) {
    const _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };

    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptTableByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceReceiptTableCountByDate(input) {
    const _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
    };

    return API.peakAPI
      .post("/api/Table/GetInvoiceReceiptTableCountByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region Transaction
  DoGetTagIdByTransactionIdList(transactionIdList, transactionType) {
    let _input = {
      transactionIdList: transactionIdList,
      transactionType: transactionType,
    };
    return API.peakAPI
      .post("/api/Table/GetTagIdByTransactionIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
};
